module.exports = __webpack_public_path__ + "static/media/Spotify.bd307d24.svg";